import axios from 'axios';
import {
  createWebHistory,
  createRouter
} from "vue-router";
import map from '@/components/map_main.vue'
import login from '@/components/login_main.vue'
import log from '@/components/log_main.vue'
import list_project from '@/components/list_project.vue'
// import main_inside from '@/components/main_inside/main_inside.vue'
// ✅ lazy-load หน้า /inside (ไฟล์ใหญ่ + widget/echarts/apexcharts) — แยก chunk ไม่ให้ถ่วง bundle แรก
const main_dangdrop_inside = () => import(/* webpackChunkName: "inside" */ '@/components/main_inside/main_dangdrop_inside.vue')

import User_Createuser from "../components/settings/users/createuser_page.vue";
import User_Listuser from '../components/settings/users/listuser_pages.vue'
import Device_Createdevice from "../components/settings/devices/createdevice_page.vue"
import Device_Listdevice from "../components/settings/devices/listdevice_page.vue"
import Device_template from "../components/settings/devices/create_template_data.vue"
import Device_Listtemplate from "../components/settings/devices/list_template_data.vue"
import group_Listplan from "../components/settings/group/listgroup_page.vue"
import GroupPlan from "../components/settings/group/group_plan_page.vue"
import GroupUser from "../components/settings/group/group_user_page.vue"
import Group_Createpage from "@/components/settings/group/creategroup_page.vue";
import plan_Listplan from "../components/settings/plan/listplan_page.vue"
import Plan_Createpage from "../components/settings/plan/createplan_page.vue"
import Info from "../components/settings/infopage/user_info.vue"

const routes = [
  // User router link
  {
  path: "/settings/info",
  name: "info",
  component: Info,
},
  {
    path: "/settings/user/createuser",
    name: "createuser",
    component: User_Createuser,
    meta: { requiresAuth: true }
  },
  {
    path: "/settings/user/listuser",
    name: "listuser",
    component: User_Listuser,
    meta: { requiresAuth: true }
  },
  {
    path: "/settings/device/create",
    name: "createdevice",
    component: Device_Createdevice,
    meta: { requiresAuth: true }
  },
  {
    path: "/settings/device/templatecreate",
    name: "createdevice_template",
    component: Device_template,
    meta: { requiresAuth: true }
  },
  {
    path: "/settings/device/listtemplate",
    name: "device_listtemplate",
    component: Device_Listtemplate,
    meta: { requiresAuth: true }
  },
  
  {
    path: "/settings/device/list",
    name: "listdevice",
    component: Device_Listdevice,
    meta: { requiresAuth: true }
  },
  {
    path: "/settings/plan/list",
    name: "listplan",
    component: plan_Listplan,
    meta: { requiresAuth: true }
  },
  {
    path: "/settings/plan/create",
    name: "createplan",
    component: Plan_Createpage,
    meta: { requiresAuth: true }
  },
  {
    path: "/settings/group/home",
    name: "home",
    component: group_Listplan,
    meta: { requiresAuth: true }
  },
  {
    path: "/settings/group/list",
    name: "listgroup",
    component: group_Listplan,
    meta: { requiresAuth: true }
  },
  {
    path: "/settings/group/plan/:id/:name",
    name: "group-plan",
    component: GroupPlan,
    meta: { requiresAuth: true }
  },
  {
    path: "/settings/group/user/:id/:name",
    name: "group-user",
    component: GroupUser,
    meta: { requiresAuth: true }
  },
  {
    path: "/settings/group/create",
    name: "group-create",
    component: Group_Createpage,
    meta: { requiresAuth: true }
  },

  
  
  {
    path: "/",
    name: "map",
    component: map,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/login",
    name: "login",
    component: login,
  },
  {
    path: "/project",
    name: "project",
    component: list_project,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/log",
    name: "log",
    component: log,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/inside",
    name: "main_dangdrop_inside",
    component: main_dangdrop_inside,
    meta: {
      requiresAuth: true
    }
  },

];

const router = createRouter({
  history: createWebHistory(),
  routes,
  // ✅ ทุกครั้งที่เปลี่ยนหน้า ให้เลื่อนกลับไปบนสุดเสมอ (ไม่งั้น browser จะคง scroll position เดิมจากหน้าก่อนหน้าไว้
  //    ซึ่งทำให้หน้าใหม่ เช่น main_dangdrop_inside ดูเหมือนเด้งไปอยู่ล่างสุดตอนเข้ามา)
  // ยกเว้นตอนกด back/forward ของ browser จะคืนตำแหน่ง scroll เดิมให้ (savedPosition) ตามพฤติกรรมมาตรฐาน
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0, left: 0 };
  },
});

// === Token refresh helper ===
// ยิง POST /auth/refresh ทุกครั้งที่เปลี่ยนหน้า/รีเฟรช เพื่อต่ออายุ accessToken
// คืน accessToken ใหม่ถ้าสำเร็จ ; คืน null ถ้าล้มเหลว
async function refreshAccessToken() {
  const refreshToken = localStorage.getItem('refreshToken')
  if (!refreshToken) return null
  try {
    const res = await axios.post(`${process.env.VUE_APP_API_URL}/auth/refresh`, {
      refreshToken
    }, {
      headers: { 'Content-Type': 'application/json' }
    })
    const newAccess = res?.data?.accessToken
    if (newAccess) {
      localStorage.setItem('accessToken', newAccess)
      return newAccess
    }
    return null
  } catch (e) {
    console.warn('refresh token failed:', e?.response?.status || e?.message)
    return null
  }
}

router.beforeEach(async (to, from, next) => {
  // ทุกการเปลี่ยนหน้า/รีเฟรช → พยายาม refresh accessToken ก่อน (ถ้ามี refreshToken)
  // ไม่บล็อค flow ถ้า refresh ล้มเหลวบนหน้า public — ปล่อยให้เข้าหน้านั้นได้
  await refreshAccessToken()

  const token = localStorage.getItem('accessToken')

  if (to.meta.requiresAuth) {
    if (!token) {
      return next('/login')
    }

    try {
      await axios.get(`${process.env.VUE_APP_API_URL}/auth/test`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      next() // ไปหน้าต่อไปได้
    } catch (err) {
      // ลองขอ refresh อีกครั้งหากการ verify ล้มเหลว (เผื่อ token หมดอายุพอดีก่อน verify)
      const fresh = await refreshAccessToken()
      if (fresh) {
        try {
          await axios.get(`${process.env.VUE_APP_API_URL}/auth/test`, {
            headers: { Authorization: `Bearer ${fresh}` }
          })
          return next()
        } catch (e2) { /* fallthrough */ }
      }
      // token หมดอายุ/ไม่ถูกต้อง หรือเซิร์ฟเวอร์ไม่ตอบ
      localStorage.removeItem('accessToken')
      // ไม่ลบ refreshToken เพื่อกัน user ลง login ครั้งเดียวแล้ว session ตาย ; ถ้าต้องการบังคับ login จริงๆ จะลบทั้งคู่ก็ได้
      next('/login')
    }
  } else {
    next()
  }
})

export default router;